import app from 'flarum/forum/app';
app.initializers.add('val-ui-lightbox', () => {
  const selector = '.Post-body a[href], .ValMemberFile-view[href]';

  /*
   * Pièces jointes images importées de phpBB.
   *
   * Leur accès réel est protégé côté serveur.
   * Ici, on améliore seulement leur présentation pour les invités.
   */
  function isPhpbbImportedImage(url) {
    if (!url) return false;
    try {
      const parsed = new URL(url, window.location.href);
      return /\/assets\/files\/(?:.*\/)?phpbb-[0-9]+\.(?:avif|bmp|gif|jpe?g|png|svg|webp)$/i.test(parsed.pathname);
    } catch (e) {
      return false;
    }
  }
  function isGuest() {
    return !(app.session && app.session.user);
  }
  function makeGuestPlaceholder() {
    const span = document.createElement('span');
    span.className = 'val-phpbb-image-login';
    span.textContent = 'Connectez-vous pour voir les images.';
    return span;
  }

  /*
   * Remplace les anciennes pièces jointes phpBB par un message
   * chez les visiteurs non connectés.
   *
   * On traite :
   * - les previews FoF Upload entourées d'un lien ;
   * - un éventuel <img> direct.
   */
  function protectGuestPhpbbImages() {
    if (!isGuest()) return;
    document.querySelectorAll('.Post-body a[href]').forEach(link => {
      if (!isPhpbbImportedImage(link.href) || !link.isConnected) {
        return;
      }
      link.replaceWith(makeGuestPlaceholder());
    });
    document.querySelectorAll('.Post-body img[src]').forEach(img => {
      if (!isPhpbbImportedImage(img.src) || !img.isConnected) {
        return;
      }
      const link = img.closest('a[href]');
      if (link && link.closest('.Post-body')) {
        link.replaceWith(makeGuestPlaceholder());
      } else {
        img.replaceWith(makeGuestPlaceholder());
      }
    });
  }
  function isImageLink(link) {
    if (!link || !link.href) return false;

    /*
     * Sécurité supplémentaire :
     * une ancienne image phpBB ne doit jamais ouvrir
     * la lightbox chez un invité, même avant son remplacement DOM.
     */
    if (isGuest() && isPhpbbImportedImage(link.href)) {
      return false;
    }

    /*
     * Bouton « Voir » de Modération > Membres.
     * Il n'est généré que pour les fichiers images.
     */
    if (link.classList.contains('ValMemberFile-view')) {
      return true;
    }
    if (link.classList.contains('FoFUpload--Upl-Image-Preview-Link')) {
      return true;
    }
    try {
      const url = new URL(link.href, window.location.href);
      return /\.(?:avif|bmp|gif|jpe?g|png|svg|webp)$/i.test(url.pathname);
    } catch (e) {
      return false;
    }
  }
  let overlay = null;
  let image = null;
  let title = null;
  let counter = null;
  let prev = null;
  let next = null;
  let current = -1;
  let items = [];
  function collect() {
    items = Array.from(document.querySelectorAll(selector)).filter(isImageLink);
  }
  function label(link) {
    const img = link.querySelector('img');
    return link.getAttribute('data-val-lightbox-title') || img?.getAttribute('alt') || img?.getAttribute('title') || link.textContent?.trim() || link.href.split('/').pop() || '';
  }
  function show(index) {
    collect();
    if (!items.length) return;
    current = (index + items.length) % items.length;
    const link = items[current];
    image.src = link.href;
    image.alt = label(link);
    title.textContent = label(link);
    counter.textContent = 'Image ' + (current + 1) + ' sur ' + items.length;
    prev.hidden = items.length < 2;
    next.hidden = items.length < 2;
    overlay.classList.add('is-open');
    document.documentElement.classList.add('val-lightbox-open');
  }
  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('val-lightbox-open');
    image.removeAttribute('src');
    current = -1;
  }
  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'val-lightbox';
    overlay.innerHTML = `
            <button class="val-lightbox-close"
                    type="button"
                    aria-label="Fermer">×</button>

            <button class="val-lightbox-prev"
                    type="button"
                    aria-label="Image précédente">‹</button>

            <div class="val-lightbox-content">
                <img class="val-lightbox-image" alt="">
                <div class="val-lightbox-info">
                    <span class="val-lightbox-title"></span>
                    <span class="val-lightbox-counter"></span>
                </div>
            </div>

            <button class="val-lightbox-next"
                    type="button"
                    aria-label="Image suivante">›</button>
        `;
    document.body.appendChild(overlay);
    image = overlay.querySelector('.val-lightbox-image');
    title = overlay.querySelector('.val-lightbox-title');
    counter = overlay.querySelector('.val-lightbox-counter');
    prev = overlay.querySelector('.val-lightbox-prev');
    next = overlay.querySelector('.val-lightbox-next');
    overlay.querySelector('.val-lightbox-close').addEventListener('click', close);
    prev.addEventListener('click', e => {
      e.stopPropagation();
      show(current - 1);
    });
    next.addEventListener('click', e => {
      e.stopPropagation();
      show(current + 1);
    });
    overlay.addEventListener('click', e => {
      if (e.target === overlay) {
        close();
      }
    });
  }
  document.addEventListener('click', e => {
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
      return;
    }
    const link = e.target.closest(selector);
    if (!link || !isImageLink(link)) {
      return;
    }
    e.preventDefault();
    build();
    collect();
    show(items.indexOf(link));
  });
  document.addEventListener('keydown', e => {
    if (!overlay?.classList.contains('is-open')) {
      return;
    }
    if (e.key === 'Escape') {
      close();
    } else if (e.key === 'ArrowLeft') {
      show(current - 1);
    } else if (e.key === 'ArrowRight') {
      show(current + 1);
    }
  });

  /*
   * Les posts Flarum sont chargés/redessinés dynamiquement.
   */
  const installGuestProtection = () => {
    protectGuestPhpbbImages();
    if (!document.body) return;
    const observer = new MutationObserver(() => {
      protectGuestPhpbbImages();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installGuestProtection, {
      once: true
    });
  } else {
    installGuestProtection();
  }
});